<!-- components/FooterSection.vue -->
<template>
  <footer class="bg-gradient-to-r from-green-800 to-green-900 text-white py-12">
    <div class="container mx-auto px-4">
      <div class="grid grid-cols-1 md:grid-cols-4 gap-8">
        <!-- Logo et Description -->
        <div class="col-span-1 md:col-span-2">
          <div class="flex items-center space-x-3 mb-4">
            <div class="w-10 h-10 p-1 bg-white/90 rounded-full flex items-center justify-center">
<!--              <svg class="w-6 h-6 text-green-800" fill="currentColor" viewBox="0 0 24 24">-->
<!--                <path d="M12 2L13.09 8.26L20 9L13.09 9.74L12 16L10.91 9.74L4 9L10.91 8.26L12 2Z"/>-->
<!--              </svg>-->
              <NuxtLink to="/" class="h-full flex items-center">
                <img
                    src="/logo.png"
                    alt="Logo"
                    class="h-full w-auto max-h-full object-contain"
                />
              </NuxtLink>
            </div>
            <h3 class="text-xl font-bold">{{ t('app.name') }}</h3>
          </div>
          <p class="text-green-100 mb-4 max-w-md">
            {{ t('app.description') }}
          </p>
          <SocialNetwork />
        </div>

        <!-- Liens Rapides -->
        <div>
          <h4 class="text-lg font-semibold mb-4">{{ t('footer.quickLinks') }}</h4>
          <ul class="space-y-2">
            <li><NuxtLink to="/" class="text-green-200 hover:text-white transition-colors">{{ t('nav.home') }}</NuxtLink></li>
            <li><NuxtLink to="/about-us" class="text-green-200 hover:text-white transition-colors">{{ t('nav.aboutUs') }}</NuxtLink></li>
            <li><NuxtLink to="/#services" class="text-green-200 hover:text-white transition-colors">{{ t('nav.services') }}</NuxtLink></li>
            <li><NuxtLink to="/realisations" class="text-green-200 hover:text-white transition-colors">{{ t('nav.realisation') }}</NuxtLink></li>
<!--            <li><NuxtLink to="/about-us" class="text-green-200 hover:text-white transition-colors">{{ t('nav.aboutUs') }}</NuxtLink></li>-->
<!--            <li><NuxtLink to="/blog" class="text-green-200 hover:text-white transition-colors">{{ t('nav.blog') }}</NuxtLink></li>-->
            <li><NuxtLink to="/faq" class="text-green-200 hover:text-white transition-colors">{{ t('nav.faq') }}</NuxtLink></li>
<!--            <li><NuxtLink to="/forum" class="text-green-200 hover:text-white transition-colors">{{ t('nav.forum') }}</NuxtLink></li>-->
          </ul>
        </div>

        <!-- Support -->
        <div>
          <h4 class="text-lg font-semibold mb-4">{{ t('footer.support') }}</h4>
          <ul class="space-y-2">
<!--            <li><a href="#" class="text-green-200 hover:text-white transition-colors">{{ t('footer.helpCenter') }}</a></li>-->
            <li><a href="/contact" class="text-green-200 hover:text-white transition-colors">{{ t('footer.contact') }}</a></li>
<!--            <li><a href="#" class="text-green-200 hover:text-white transition-colors">{{ t('footer.documentation') }}</a></li>-->
            <li><a href="/privacy-policy" class="text-green-200 hover:text-white transition-colors">{{ t('footer.privacy') }}</a></li>
          </ul>
        </div>
      </div>

      <!-- Ligne de séparation -->
      <div class="border-t border-green-700 mt-8 pt-6">
        <div class="flex flex-col md:flex-row justify-between items-center">
          <p class="text-green-200 text-sm">
            &copy; {{ new Date().getFullYear() }} {{ t('footer.copyright',{
            author:t('app.name')
          }) }}
          </p>
          <div class="flex space-x-6 mt-4 md:mt-0">
            <NuxtLink to="/privacy-policy/privacy" class="text-green-200 hover:text-white text-sm transition-colors">{{ t('footer.terms') }}</NuxtLink>
            <NuxtLink to="/privacy-policy/terms " class="text-green-200 hover:text-white text-sm transition-colors">{{ t('footer.privacy') }}</NuxtLink>
            <NuxtLink to="/privacy-policy/cookies" class="text-green-200 hover:text-white text-sm transition-colors">{{ t('footer.cookies') }}</NuxtLink>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup lang="ts">
// Aucune logique spécifique nécessaire pour le footer
const { t } = useI18n()
</script>